import { render, staticRenderFns } from "./AttestationSettings.vue?vue&type=template&id=774a9066&"
import script from "./AttestationSettings.vue?vue&type=script&lang=js&"
export * from "./AttestationSettings.vue?vue&type=script&lang=js&"
import style0 from "./AttestationSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports